import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VChip } from 'vuetify/lib/components/VChip';
import { VChipGroup } from 'vuetify/lib/components/VChipGroup';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VCombobox } from 'vuetify/lib/components/VCombobox';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
import Intersect from 'vuetify/lib/directives/intersect';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c(VRow, {
    staticClass: "m-0 p-0",
    class: _vm.dense ? 'dense' : ''
  }, [_c(VCol, {
    attrs: {
      "cols": _vm.cols['category']['cols'],
      "md": _vm.cols['category']['md'],
      "lg": _vm.cols['category']['lg']
    }
  }, [_c(VAutocomplete, {
    attrs: {
      "item-text": "text",
      "item-value": "param",
      "items": _vm.searchTypes,
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "label": _vm.$i18n_t('DigitalTwin.DigitalTwin.list.searchCategory'),
      "return-object": "",
      "hide-details": "",
      "readonly": _vm.readonly,
      "dense": _vm.dense,
      "data-cy": `search_type_${_vm.get(_vm.modelSearchType, 'param')}`
    },
    on: {
      "input": _vm.updateSearchType
    },
    model: {
      value: _vm.modelSearchType,
      callback: function ($$v) {
        _vm.modelSearchType = $$v;
      },
      expression: "modelSearchType"
    }
  })], 1), _vm.get(_vm.modelSearchType, 'param') === 'keyValue' || _vm.get(_vm.modelSearchType, 'param') === 'ddrTarget' || _vm.get(_vm.modelSearchType, 'param') === 'ddrDestination' ? _c(VCol, {
    attrs: {
      "cols": _vm.cols['keyBox']['cols'],
      "md": _vm.cols['keyBox']['md'],
      "lg": _vm.cols['keyBox']['lg']
    }
  }, [!Array.isArray(_vm.get(_vm.modelSearchType, 'items')) && !_vm.useCustomSearch ? [_c(VTextField, {
    attrs: {
      "label": _vm.$i18n_t('Common.searchKey'),
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "hide-details": "",
      "readonly": _vm.readonly,
      "dense": _vm.dense,
      "data-cy": `search_key_${_vm.get(_vm.modelSearchType, 'param')}`
    },
    on: {
      "keyup": function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        return _vm.searchKeyUpEnter.apply(null, arguments);
      }
    },
    model: {
      value: _vm.modelSearchKey,
      callback: function ($$v) {
        _vm.modelSearchKey = $$v;
      },
      expression: "modelSearchKey"
    }
  })] : [_c(VAutocomplete, {
    attrs: {
      "search-input": _vm.customSearchKeyInput,
      "label": _vm.$i18n_t('Common.searchKey'),
      "items": _vm.itemsForSearchKey,
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "return-object": _vm.get(_vm.modelSearchType, 'returnObject') !== false,
      "dense": _vm.dense,
      "hide-details": "",
      "readonly": _vm.readonly,
      "data-cy": `search_for_${_vm.get(_vm.modelSearchType, 'param')}`,
      "loading": _vm.customSearchResultLoading
    },
    on: {
      "update:searchInput": function ($event) {
        _vm.customSearchKeyInput = $event;
      },
      "update:search-input": function ($event) {
        _vm.customSearchKeyInput = $event;
      },
      "keyup": function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        return _vm.searchKeyUpEnter.apply(null, arguments);
      },
      "mousedown": _vm.fetchDdrKeys
    },
    scopedSlots: _vm._u([{
      key: "selection",
      fn: function (data) {
        return [_vm._v("\n          " + _vm._s(typeof data.item === 'string' ? data.item : data.item.text || '__INCOMPLETE_DATA__') + "\n          "), data.item.id ? [_vm._v("(" + _vm._s(_vm.$i18n_t('Common.id')) + ": " + _vm._s(data.item.id) + ")")] : _vm._e()];
      }
    }, {
      key: "append-item",
      fn: function () {
        return [_vm.customSearchResultLoading ? _c(VProgressLinear, {
          attrs: {
            "indeterminate": ""
          }
        }) : _vm._e()];
      },
      proxy: true
    }, {
      key: "item",
      fn: function (data) {
        return [_c(VListItemContent, [data.item.__doIntersect__ ? _c('div', {
          directives: [{
            def: Intersect,
            name: "intersect",
            rawName: "v-intersect",
            value: _vm.endCustomSearchIntersect,
            expression: "endCustomSearchIntersect"
          }]
        }) : _vm._e(), _c(VListItemTitle, [_vm._v("\n              " + _vm._s(typeof data.item === 'string' ? data.item : data.item.text || '__INCOMPLETE_DATA__') + "\n            ")])], 1)];
      }
    }], null, false, 4108081470),
    model: {
      value: _vm.modelSearchKey,
      callback: function ($$v) {
        _vm.modelSearchKey = $$v;
      },
      expression: "modelSearchKey"
    }
  })]], 2) : _vm._e(), _vm.get(_vm.modelSearchType, 'param') === 'parentId' ? _c(VCol, {
    attrs: {
      "cols": _vm.cols['searchBox']['cols'],
      "md": _vm.cols['searchBox']['md'],
      "lg": _vm.cols['searchBox']['lg']
    }
  }, [_c('core-dtwin-finder', {
    attrs: {
      "label": _vm.$i18n_t('Common.digitalTwins.searchParentLabel'),
      "placeholder": _vm.$i18n_t('Common.digitalTwins.searchParentPlaceholder'),
      "readonly": _vm.readonly,
      "dense": _vm.dense,
      "required": "",
      "hideDetails": "",
      "data-cy": `search_parent_${_vm.get(_vm.modelSearchType, 'param')}`
    },
    on: {
      "dtwin-selected": _vm.parentTwinSelected
    },
    model: {
      value: _vm.modelSearchKey,
      callback: function ($$v) {
        _vm.modelSearchKey = $$v;
      },
      expression: "modelSearchKey"
    }
  })], 1) : _c(VCol, {
    attrs: {
      "cols": _vm.cols['searchBox']['cols'],
      "md": _vm.cols['searchBox']['md'],
      "lg": _vm.cols['searchBox']['lg']
    }
  }, [!Array.isArray(_vm.get(_vm.modelSearchType, 'items')) && !_vm.useCustomSearch ? [_c(VTextField, {
    attrs: {
      "label": _vm.$i18n_t('Common.searchFor'),
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "dense": _vm.dense,
      "append-icon": "fal fa-search",
      "hide-details": "",
      "readonly": _vm.readonly,
      "data-cy": `search_text_field_${_vm.get(_vm.modelSearchType, 'param')}`
    },
    on: {
      "keyup": function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        return _vm.searchKeyUpEnter.apply(null, arguments);
      }
    },
    scopedSlots: _vm._u([{
      key: "append-outer",
      fn: function () {
        return [!_vm.singleSearch || _vm.searchTags.length < 1 ? _c('core-button', {
          attrs: {
            "color": _vm.color,
            "disabled": _vm.disableAddSearch,
            "prepend-icon": "fa-plus",
            "data-cy": `search_btn_${_vm.get(_vm.modelSearchType, 'param')}`
          },
          on: {
            "click": _vm.searchAdd
          }
        }) : _vm._e()];
      },
      proxy: true
    }], null, false, 991759779),
    model: {
      value: _vm.modelSearchFor,
      callback: function ($$v) {
        _vm.modelSearchFor = $$v;
      },
      expression: "modelSearchFor"
    }
  })] : [_vm.get(_vm.modelSearchType, 'combobox') ? _c(VCombobox, {
    attrs: {
      "label": _vm.$i18n_t('Common.search'),
      "items": _vm.get(_vm.modelSearchType, 'items'),
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "return-object": _vm.get(_vm.modelSearchType, 'returnObject') !== false,
      "dense": _vm.dense,
      "hide-details": "",
      "readonly": _vm.readonly,
      "data-cy": `search_combobox_${_vm.get(_vm.modelSearchType, 'param')}`
    },
    on: {
      "keyup": function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        return _vm.searchKeyUpEnter.apply(null, arguments);
      }
    },
    scopedSlots: _vm._u([{
      key: "selection",
      fn: function (data) {
        return [_vm._v("\n          " + _vm._s(typeof data.item === 'string' ? data.item : data.item.text || data.item) + "\n          "), data.item.id ? [_vm._v("(" + _vm._s(_vm.$i18n_t('Common.id')) + ": " + _vm._s(data.item.id) + ")")] : _vm._e()];
      }
    }, {
      key: "item",
      fn: function (data) {
        return [_c(VListItemContent, [_c(VListItemTitle, [_vm._v("\n              " + _vm._s(typeof data.item === 'string' ? data.item : data.item.text || data.item) + "\n              "), data.item.id ? [_vm._v("(" + _vm._s(_vm.$i18n_t('Common.id')) + ": " + _vm._s(data.item.id) + ")")] : _vm._e()], 2)], 1)];
      }
    }, {
      key: "append-outer",
      fn: function () {
        return [!_vm.singleSearch || _vm.searchTags.length < 1 ? _c('core-button', {
          attrs: {
            "color": _vm.color,
            "disabled": _vm.disableAddSearch,
            "prepend-icon": "fa-plus",
            "data-cy": "combobox_search_btn"
          },
          on: {
            "click": _vm.searchAdd
          }
        }) : _vm._e()];
      },
      proxy: true
    }], null, false, 3945866282),
    model: {
      value: _vm.modelSearchFor,
      callback: function ($$v) {
        _vm.modelSearchFor = $$v;
      },
      expression: "modelSearchFor"
    }
  }) : _c(VAutocomplete, {
    attrs: {
      "search-input": _vm.customSearchInput,
      "label": _vm.$i18n_t('Common.searchFor'),
      "items": _vm.itemsForSearchFor,
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "return-object": _vm.get(_vm.modelSearchType, 'returnObject') !== false,
      "dense": _vm.dense,
      "hide-details": "",
      "readonly": _vm.readonly,
      "data-cy": `search_for_${_vm.get(_vm.modelSearchType, 'param')}`,
      "loading": _vm.customSearchResultLoading
    },
    on: {
      "update:searchInput": function ($event) {
        _vm.customSearchInput = $event;
      },
      "update:search-input": function ($event) {
        _vm.customSearchInput = $event;
      },
      "keyup": function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
        return _vm.searchKeyUpEnter.apply(null, arguments);
      },
      "mousedown": function ($event) {
        return _vm.fetchDdrValues(_vm.modelSearchKey);
      }
    },
    scopedSlots: _vm._u([{
      key: "selection",
      fn: function (data) {
        return [_vm._v("\n          " + _vm._s(typeof data.item === 'string' ? data.item : data.item.text || '__INCOMPLETE_DATA__') + "\n          "), data.item.id ? [_vm._v("(" + _vm._s(_vm.$i18n_t('Common.id')) + ": " + _vm._s(data.item.id) + ")")] : _vm._e()];
      }
    }, {
      key: "append-item",
      fn: function () {
        return [_vm.customSearchResultLoading ? _c(VProgressLinear, {
          attrs: {
            "indeterminate": ""
          }
        }) : _vm._e()];
      },
      proxy: true
    }, {
      key: "item",
      fn: function (data) {
        return [_c(VListItemContent, [data.item.__doIntersect__ ? _c('div', {
          directives: [{
            def: Intersect,
            name: "intersect",
            rawName: "v-intersect",
            value: _vm.endCustomSearchIntersect,
            expression: "endCustomSearchIntersect"
          }]
        }) : _vm._e(), _c(VListItemTitle, [_vm._v("\n              " + _vm._s(typeof data.item === 'string' ? data.item : data.item.text || '__INCOMPLETE_DATA__') + "\n              "), data.item.id ? [_vm._v("(" + _vm._s(_vm.$i18n_t('Common.id')) + ": " + _vm._s(data.item.id) + ")")] : _vm._e()], 2)], 1)];
      }
    }, {
      key: "append-outer",
      fn: function () {
        return [!_vm.singleSearch || _vm.searchTags.length < 1 ? _c('core-button', {
          attrs: {
            "color": _vm.color,
            "disabled": _vm.disableAddSearch,
            "prepend-icon": "fa-plus",
            "data-cy": "search_for_btn"
          },
          on: {
            "click": _vm.searchAdd
          }
        }) : _vm._e()];
      },
      proxy: true
    }]),
    model: {
      value: _vm.modelSearchFor,
      callback: function ($$v) {
        _vm.modelSearchFor = $$v;
      },
      expression: "modelSearchFor"
    }
  })]], 2), _c(VCol, {
    attrs: {
      "cols": _vm.cols['displayBox']['cols'],
      "md": _vm.cols['displayBox']['md'],
      "lg": _vm.cols['displayBox']['lg']
    }
  }, [_c('div', {
    staticClass: "display-box"
  }, [_vm.showOperatorDropdown ? _c(VSelect, {
    staticClass: "operator-select",
    attrs: {
      "item-text": "text",
      "item-value": "param",
      "items": _vm.searchOperators,
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "dense": _vm.dense,
      "return-object": "",
      "hide-details": "",
      "readonly": _vm.readonly,
      "data-cy": `search_operator_${_vm.get(_vm.modelSearchType, 'param')}`
    },
    on: {
      "input": _vm.searchOperatorUpdate
    },
    model: {
      value: _vm.searchOperator,
      callback: function ($$v) {
        _vm.searchOperator = $$v;
      },
      expression: "searchOperator"
    }
  }) : _vm._e(), _c('div', {
    staticClass: "search-box"
  }, [_c(VChipGroup, {
    attrs: {
      "column": ""
    }
  }, _vm._l(_vm.searchTags, function (tag, idx) {
    return _c(VChip, {
      key: `chip-${idx}`,
      attrs: {
        "small": "",
        "close": !_vm.readonly,
        "data-cy": "search_chip"
      },
      on: {
        "click:close": function ($event) {
          return _vm.searchRemove(idx);
        }
      }
    }, [_vm._v("\n            " + _vm._s(_vm.$i18n_t('DigitalTwin.VirtualDevice.props')[tag.param] || tag.type) + ": \n            "), _c('span', {
      staticClass: "font-weight-bold"
    }, [_vm._v("\n              " + _vm._s((tag.search || {}).text === undefined ? tag.search : tag.search.text) + "\n            ")])]);
  }), 1)], 1)], 1)])], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };